import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"normal-btn-text elevation-0 rounded-tag-small ml-2",attrs:{"color":_vm.color,"loading":_vm.loadingPdf},on:{"click":_vm.gerarPdf}},[_c(VIcon,[_vm._v("mdi-file-pdf-box")]),_vm._v(" Gerar PDF ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }